// PATH: SaberpDeals/frontend/src/lib/peopleApi.ts
import { api } from './api';

export interface Person {
    id: number;
    name: string;
    defaultRole: 'Sales' | 'Technical' | 'Both';
    isActive: boolean;
    replacedByPersonId: number | null;
    replacedByName: string | null;
}

export interface PersonInput {
    name: string;
    defaultRole: 'Sales' | 'Technical' | 'Both';
}

export const peopleApi = {
    async list(): Promise<Person[]> {
        const { data } = await api.get('/api/deals/people');
        return data;
    },
    async create(input: PersonInput): Promise<Person> {
        const { data } = await api.post('/api/deals/people', input);
        return data;
    },
    async update(id: number, input: PersonInput): Promise<Person> {
        const { data } = await api.put(`/api/deals/people/${id}`, input);
        return data;
    },
    async toggle(id: number): Promise<Person> {
        const { data } = await api.post(`/api/deals/people/${id}/toggle`, {});
        return data;
    },
    async setReplacement(id: number, replacedByPersonId: number | null): Promise<Person> {
        const { data } = await api.post(`/api/deals/people/${id}/replacement`, { replacedByPersonId });
        return data;
    },
};
